import { render } from "./HHPatientDocuments.vue?vue&type=template&id=0bc0dfa5&ts=true"
import script from "./HHPatientDocuments.ts?vue&type=script&lang=ts&external"
export * from "./HHPatientDocuments.ts?vue&type=script&lang=ts&external"

import "./HHPatientDocuments.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__